import styles from "./index.module.scss";

export interface SkeletonTextLoaderProps {
    /**
     * Width of the skeleton text loader.
     * Can be a percentage or fixed width (e.g., "100%", "200px").
     */
    width?: string;
    lineCount?: number;
}

export const SkeletonTextLoader = ({
    lineCount = 1,
    width = "100%"
}: SkeletonTextLoaderProps) => {
    return (
        <div className={styles["skeleton-text-loader"]} style={{ width }}>
            {Array.from({ length: lineCount }).map((_, index) => (
                <div key={index} className={styles["skeleton-line"]} />
            ))}
        </div>
    );
};
